<div [class]="isDirectLogin ? 'e-process-page' : 'e-process-page added-height'">
    <div class="page-wrap">
        <div class="main-content">
            <!-- User logs in when there are only updated system docs OR during new user set up -->
            <ng-container
                *ngIf="requiredDocs.length > 0 && (newSystemDocs.length > 0 || firstTimeLoginToAcceptSystemDocs())">
                <form (ngSubmit)="nextStep()" [ngClass]="!moreAgreements ? 'display' : 'display-none'">
                    <h1 *ngIf="showTitle">Agreements</h1>
                    <div *ngFor="let doc of newSystemDocs" class="check-wrap">
                        <mat-checkbox checked="{{ initiallyChecked }}"
                            (change)="toggleIsChecked(doc, $event)"></mat-checkbox>

                        <div *ngIf="doc.systemDocumentTypeId === SystemDocumentType.DPA; else tosAndPrivacy">
                            <p>
                                I am authorized to enroll and set up this location in EZ DOCS and have system
                                administrator rights.
                            </p>
                            <p>
                                You can cancel at any time by contacting EZ DOCS Support.
                                <span (click)="systemDocumentDialog(doc.systemDocumentDescription)">Read the terms of
                                    participation here</span>.
                            </p>
                        </div>
                        <ng-template #tosAndPrivacy>
                            <p>
                                I have read, understand, and agree to the
                                <span [ngSwitch]="doc.systemDocumentDescription">
                                    <span *ngSwitchCase="'TOS'"
                                        (click)="systemDocumentDialog(doc.systemDocumentDescription)">End User
                                        Agreement.</span>
                                    <span *ngSwitchCase="'Privacy'"
                                        (click)="systemDocumentDialog(doc.systemDocumentDescription)">Privacy
                                        Policy.</span>
                                </span>
                            </p>
                        </ng-template>
                    </div>
                    <div *ngIf="showButtons" class="button-container">
                        <button (click)="goBack()" class="mt-2 cancel-btn" type="button" mat-button>
                            {{ title }}
                        </button>
                        <button class="mt-2" type="submit" [disabled]="!allDocsChecked"
                            [ngClass]="allDocsChecked ? 'continue-btn' : 'disabled-btn'" mat-button>
                            Continue
                        </button>
                    </div>
                </form>

                <form *ngIf="newReleaseNotes.length" (ngSubmit)="continue()"
                    [ngClass]="moreAgreements ? 'display' : 'display-none'">
                    <h1 *ngIf="showTitle">Release Notes</h1>
                    <div class="release-doc-container">
                        <!-- release notes are displayed in this container -->
                    </div>
                    <div *ngIf="showButtons" class="button-container">
                        <button (click)="firstStep()" class="mt-2 cancel-btn" type="button" mat-button>Go Back</button>
                        <button class="mt-2 continue-btn" type="submit" mat-button>Continue</button>
                    </div>
                </form>
            </ng-container>

            <!-- User logs in when there are only updated release notes -->
            <ng-container *ngIf="newReleaseNotes.length && newSystemDocs.length <= 0">
                <form (ngSubmit)="continue()">
                    <h1 *ngIf="showTitle">Release Notes</h1>
                    <div class="release-doc-container">
                        <!-- release notes are displayed in this container -->
                    </div>
                    <div *ngIf="showButtons" class="button-container">
                        <button (click)="logout()" class="mt-2 cancel-btn" type="button" mat-button>Log Out</button>
                        <button class="mt-2 continue-btn" type="submit" mat-button>Continue</button>
                    </div>
                </form>
            </ng-container>

            <ng-container *ngIf="requiredDocs.length <= 0">
                <div class="center-content">
                    <h2>There are currently no documents to be accepted</h2>

                    <button *ngIf="showButtons" class="mt-2 no-docs-btn" type="button" (click)="continue()"
                        mat-button>Continue</button>
                </div>
            </ng-container>
        </div>
    </div>
</div>